window.addEventListener("load", (event) => {
  let proId = document.querySelector(".detoxify-skin-sec").getAttribute("data-pro"); 
    let config = {
      productId: Number(proId), // Required
      injectionParent: `[data-form-id="block_id_${proId}"]`, // The node that will have the widget injected in
      injectionMethod: 'prepend', // How will the widget be injected 
      injectFn: (node, target) => {}, // Runs a custom injection function 
      selectors: {
            price: [`.price-item`]    
      }
    };  
    setTimeout(() => {       
      window.ReChargeWidget.createWidget(config);        
    } , 1000);
});